<template>
  <div class="footer">
    <span>Copyright © 2026 聊城市青少年综合服务中心（聊城市青少年文化宫） 版权所有</span>
    <br />
    <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">鲁ICP备2024071331号</a>
  </div>
</template>

<script>
export default {
  name: "FooterBar"
}
</script>

<style scoped>
.footer {
  font-size: 12px;
  text-align: center;
  overflow: hidden;
  color: #999;
}

.icp-link {
  color: #999;
  text-decoration: none;
}

.icp-link:hover {
  color: #409eff;
}
</style>
